import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import WButton from "../wbutton/WButton";
import router from "next/router";
import clsx from "clsx";
import { motion } from "framer-motion";
import parse from "html-react-parser";
import fbEvent from "@/utils/fbEvent";

/* eslint-disable-next-line */
export interface LHeroSectionTwoProps {
  id?: string;
  topText?: string; //rich text
  mainTitle: string;
  image?: {
    url: string;
    altTag: string;
  };
  button: {
    text: string;
    url: string;
  };
  bottomText?: string; //rich text
  textAfterButton?: boolean;
  belowTitleText?: string;
}

export function LHeroSectionTwo(props: LHeroSectionTwoProps) {
  return (
    <div
      id={props?.id}
      className="relative w-full pt-10 bg-ekblue lg:pt-32 lg:pb-14 lg:bg-[url('/img/hero-section-bg.webp')] bg-none bg-contain bg-no-repeat bg-right-top"
    >
      <div className="container z-20 flex flex-col items-center gap-10 px-4 pt-12 pb-0 mx-auto lg:flex-row lg:py-20 lg:max-w-7xl">
        <div className="flex flex-col w-full gap-8 lg:w-1/2">
          {props?.topText && (
            <motion.div
              className="order-1 text-2xl green-markdown"
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{ duration: 1, type: "spring", delay: 0.1 }}
            >
              <ReactMarkdown
                // disable es-lint because react-markedown decided its a "good" idea to call the prop "children"
                // eslint-disable-next-line react/no-children-prop
                children={props?.topText}
              />
            </motion.div>
          )}
          <motion.div
            className="order-2"
            initial={{ opacity: 0, y: -30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{ duration: 1, type: "spring", delay: 0.2 }}
          >
            <h1 className="text-white">{parse(props?.mainTitle)}</h1>
          </motion.div>
          {props?.belowTitleText && (
            <motion.div
              className="order-3 text-white"
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{ duration: 1, type: "spring", delay: 0.2 }}
            >
              <div>{props?.belowTitleText}</div>
            </motion.div>
          )}

          {props?.bottomText && (
            <motion.div
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{ duration: 1, type: "spring", delay: 0.3 }}
              className={clsx([
                props?.textAfterButton ? "order-last" : "order-4",
                "font-normal white-markdown",
              ])}
            >
              <ReactMarkdown
                // disable es-lint because react-markedown decided its a "good" idea to call the prop "children"
                // eslint-disable-next-line react/no-children-prop
                children={props?.bottomText}
              />
            </motion.div>
          )}
          {props?.button && (
            <motion.div
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: false }}
              transition={{ duration: 0.5, type: "spring", delay: 0.3 }}
              className="order-4"
            >
              <WButton
                text={props?.button.text}
                type="primary-red-btn"
                className="w-full lg:w-fit"
                onClick={() => {
                  props?.button?.url && router.push(props?.button?.url);
                  fbEvent("Schedule");
                }}
              />
            </motion.div>
          )}
        </div>
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{ duration: 1, type: "spring", delay: 0.5 }}
          className="right-0 z-10 flex justify-end w-full h-full mb-4 lg:mb-0 lg:mr-0 lg:w-1/2 lg:absolute"
        >
          <img
            src={props?.image?.url}
            alt={props?.image?.altTag}
            className="lg:object-contain lg:max-w-2xl"
          />
        </motion.div>
      </div>
    </div>
  );
}

export default LHeroSectionTwo;
